module.exports = __webpack_public_path__ + "static/media/exames_01.7d53b080.jpg";